import React from 'react';
import { apiFetchData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';

export default class BlogSuggestions extends React.Component {
    constructor(props) {
        super(props);
        this.pathExtension = 'blog/suggestion/';
        this.state = {
            publicResources: null,
            blogs: [],
        };
        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const propsData = this.props;
        apiFetchData(this.pathExtension, `/6/${propsData.category}/0`)
            .then((res) => {
                if (res.status === 200) {
                    this.setState((prevState) => ({
                        blogs: [...prevState.blogs, ...res.data.blogItems],
                        publicResources: res.data,
                    }));
                    return;
                }
                reportError(res);
            })
            .catch((err) => {
                // this.setState({
                //     errorMsg: err,
                // });
                reportError(err);
            })
            .finally(() => {
                // this.setState({
                //     isLoading: false,
                // });
            });
    }

    render() {
        const fetchData = this.state;
        return (
            <>
                {fetchData.publicResources && (
                    <div>
                        <div className="row blog-suggestions">
                            <div className="col-md-12">
                                <h3 className="mt-0 blogSubtitle">{fetchData.publicResources.introTextTitle}</h3>
                            </div>
                            <div className="col-md-12 aboutUsText card-group">
                                {fetchData.blogs.map((item, index) => (
                                    <div className="blog-suggestions__item cardWrapper" key={index}>
                                        <a className="blog-suggestions__link" href={item.readMoreURL}>
                                            <div className="blog-suggestions__card card">
                                                <img
                                                    loading="lazy"
                                                    className="blog-suggestions__image"
                                                    src={item.image.sourceURL}
                                                    srcSet={[
                                                        `${item.image.sourceURL} 1x`,
                                                        item.imageSourceURLLargeSizeAlternative ? `${item.imageSourceURLLargeSizeAlternative} 2x` : '',
                                                        item.imageSourceURLLargeSizeAlternative ? `${item.imageSourceURLLargeSizeAlternative} 3x` : '',
                                                    ]
                                                        .filter(Boolean)
                                                        .join(', ')}
                                                    alt={item.image.altText}
                                                    title={item.image.titleText}
                                                    width={286}
                                                    height={190}
                                                    style={{ aspectRatio: `${286} / ${190}` }}
                                                />
                                                <div className="card-body">
                                                    <span className="blog-suggestions__publish-date">{item.publishDate}</span>
                                                    <h4 className="blog-suggestions__title">{item.title}</h4>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}
